import gql from 'graphql-tag'
import GqlClient from '../lib/GqlClient'
import Logger from '@/lib/Logger'

import ClEntry from '@/models/ClEntry'

class ClInstanceEntry {
  static attributeNames() {
    return ['id', 'clEntryId', 'clInstanceId', 'status']
  }
  // -
  static getClean(dirtyObj) {
    Logger.debug('dirtyObj', dirtyObj)
    let cleanObject = {}
    this.attributeNames().forEach(attrname => {
      if (attrname in dirtyObj) {
        cleanObject[attrname] = dirtyObj[attrname]
      }
    })
    Logger.debug('cleanObject:', cleanObject)
    return cleanObject
  }

  static async create(entryId, instance) {
    Logger.debug('ClInstanceEntry.create', entryId, instance)
    const instanceEntry = { clEntryId: entryId, clInstanceId: instance.id }

    return GqlClient.runMutation({
      mutation: gql`
        mutation($input: ClInstanceEntryInput!) {
          clInstanceEntryAdd(input: $input) {
            id
          }
        }
      `,
      variables: {
        input: instanceEntry,
      },
    })
  }

  static changeEntry(instanceEntry, entry) {
    Logger.debug('ClInstanceEntry.changeEntry', instanceEntry, entry)
    return GqlClient.runMutation({
      dataKey: 'clInstanceEntryContentChange',
      mutation: gql`
        mutation($id: ID!, $entry: ClEntryInput!) {
          clInstanceEntryContentChange(clInstanceEntryId: $id, input: $entry) {
            clInstanceEntry {
              id
            }
          }
        }
      `,
      variables: {
        id: instanceEntry.id,
        entry: ClEntry.getClean(entry),
      },
    })
  }

  // static save(entry) {
  //   Logger.debug('ClInstanceEntry.save', entry)
  //   return GqlClient.runMutation({
  //     dataKey: 'clInstanceEntryChange',
  //     mutation: gql`
  //       mutation($input: ClInstanceEntryInput!) {
  //         clInstanceEntryChange(input: $input) {
  //           clInstanceEntry {
  //             id
  //           }
  //         }
  //       }
  //     `,
  //     variables: {
  //       input: ClEntry.getClean(entry),
  //     },
  //   })
  // }

  static delete(id) {
    Logger.debug('ClInstanceEntry.delete', id)
    return GqlClient.runMutation({
      mutation: gql`
        mutation($id: ID!) {
          clInstanceEntryDelete(clInstanceEntryId: $id) {
            info
          }
        }
      `,
      variables: {
        id: id,
      },
    })
  }

  static setChecked(id, checked_status) {
    Logger.debug('ClInstanceEntry.setChecked', id, checked_status)
    let status = null
    if (checked_status) status = 'checked'
    else status = 'unchecked'

    return GqlClient.runMutation({
      dataKey: 'clInstanceEntrySetStatus',
      mutation: gql`
        mutation($id: ID!, $status: String!) {
          clInstanceEntrySetStatus(id: $id, status: $status) {
            clInstanceEntry {
              id
              status
            }
          }
        }
      `,
      variables: {
        id,
        status,
      },
    })
  }
}

export default ClInstanceEntry
